import { Col, Divider, Row } from 'antd';
import classNames from 'classnames/bind';
import moment from 'moment';
import styled from 'styled-components';
import styles from './DetailInfoClientSection.module.scss';

const cx = classNames.bind(styles);

const Item = styled.div`
    .ant-divider-horizontal {
        margin: 14px 0px;
    }
`;

const DetailInfoClientSection = ({ item }) => {
    return (
        <Item>
            <div className={cx('container')}>
                <Row align="middle" className={cx('name_section')}>
                    Appointment information
                </Row>
                <Divider style={{ borderTop: '2px solid rgba(0,0,0,.06)' }} />
                <Row align="middle">
                    <Col xs={4}>
                        <Row className={cx('label')}>Name: </Row>
                    </Col>
                    <Col xs={20}>
                        <Row className={cx('content')} justify="end">
                            {item.name}
                        </Row>
                    </Col>
                </Row>
                <Divider style={{ borderTop: '2px solid rgba(0,0,0,.06)' }} />
                <Row align="middle">
                    <Col xs={10}>
                        <Row className={cx('label')}>Phone number: </Row>
                    </Col>
                    <Col xs={14}>
                        <Row className={cx('content')} justify="end">
                            {item.phone}
                        </Row>
                    </Col>
                </Row>
                <Divider style={{ borderTop: '2px solid rgba(0,0,0,.06)' }} />
                <Row align="middle">
                    <Col xs={10}>
                        <Row className={cx('label')}>Time: </Row>
                    </Col>
                    <Col xs={14}>
                        <Row className={cx('content')} justify="end">
                            {moment(new Date(parseInt(item.time_start))).format('HH:mm, DD/MM/YYYY')}
                        </Row>
                    </Col>
                </Row>
                <Divider style={{ borderTop: '2px solid rgba(0,0,0,.06)' }} />
                <Row align="middle">
                    <Col xs={10}>
                        <Row className={cx('label')}>Special requirements: </Row>
                    </Col>
                    <Col xs={14}>
                        <Row className={cx('content')} justify="end">
                            {item.message}
                        </Row>
                    </Col>
                </Row>
                <Divider style={{ borderTop: '2px solid rgba(0,0,0,.06)' }} />
                <Row align="middle">
                    <Col xs={10}>
                        <Row className={cx('label')}>Branch: </Row>
                    </Col>
                    <Col xs={14}>
                        <Row className={cx('content')} justify="end">
                            {item.branch?.name}
                        </Row>
                    </Col>
                </Row>
            </div>
        </Item>
    );
};

export default DetailInfoClientSection;
